import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import AppLoadingIndicator from '../components/common/AppLoadingIndicator';
import { useTranslation } from 'react-i18next';
import { jwtDecode } from 'jwt-decode';
import { Auth0JWT } from 'components/common/props-types';

const HomePage = (): JSX.Element | null => {
  const { i18n } = useTranslation();
  const { isAuthenticated, isLoading, loginWithRedirect, getAccessTokenSilently } = useAuth0();
  const [redirectPath, setRedirectPath] = useState<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated) return;

    const checkToken = async () => {
      try {
        const token = await getAccessTokenSilently();

        if (token) {
          const jwtInfo: Auth0JWT = jwtDecode(token);
          const { redirect_complete_account } = jwtInfo;

          if (redirect_complete_account) {
            setRedirectPath(i18n.resolvedLanguage === 'fr' ? '/fr/Inscription' : '/en/Register');
          } else {
            setRedirectPath(i18n.resolvedLanguage === 'fr' ? '/fr/Compte/Parametres' : '/en/Account/Settings');
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error getting token:', error);
      }
    };

    checkToken();
  }, [isAuthenticated, getAccessTokenSilently, i18n.resolvedLanguage]);

  if (isLoading) {
    return <AppLoadingIndicator />;
  }

  if (!isAuthenticated) {
    loginWithRedirect();
    return null;
  }

  return <Navigate replace to={redirectPath!} />;
};

export default HomePage;
